// 点数（credit）充值（用户端）：/api/user/*
import apiClient from '../client'

export interface CreditPackageItem {
  id: number
  title: string
  price: number
  marketPrice: number
  credit: number
  bonusCredit: number
  description: string
}

export interface RechargeInfo {
  packages: CreditPackageItem[]
  channels: string[]
  credit: number
}

export const getRechargeInfo = async (): Promise<RechargeInfo> => {
  const resp = await apiClient.post('/api/user/recharge/package', {})
  return resp.data.data
}

export interface RechargeOrderResult {
  orderNo: string
  payType: string
  payUrl: string
  qrCode: string
  credit: number
}

export const submitRecharge = async (packageId: number, payType: string): Promise<RechargeOrderResult> => {
  const resp = await apiClient.post('/api/user/recharge/submit', { packageId, payType })
  return resp.data.data
}

export const getRechargeStatus = async (orderNo: string): Promise<{
  orderNo: string
  status: number
  payed: boolean
  credit: number
}> => {
  const resp = await apiClient.post('/api/user/recharge/status', { orderNo })
  return resp.data.data
}

export const getMyCredit = async (): Promise<{
  credit: number
  totalPurchased: number
  totalConsumed: number
}> => {
  const resp = await apiClient.post('/api/user/credit/info', {})
  return resp.data.data
}

export interface CreditLogItem {
  id: number
  createdAt: string
  userId: number
  change: number
  balance: number
  type: string
  refType: string
  refId: number
  remark: string
}

export const listMyCreditLogs = async (params: { page: number; pageSize: number }): Promise<{
  records: CreditLogItem[]
  total: number
}> => {
  const resp = await apiClient.post('/api/user/credit/logs', params)
  return resp.data.data
}

export interface MyCreditOrderItem {
  id: number
  orderNo: string
  title: string
  price: number
  credit: number
  status: number
  payType: string
  createdAt: string
  timePay: string | null
  /** 累计退款金额（元） */
  refundAmount: number
  timeRefund: string | null
}

export const listMyCreditOrders = async (params: { page: number; pageSize: number }): Promise<{
  records: MyCreditOrderItem[]
  total: number
}> => {
  const resp = await apiClient.post('/api/user/creditOrder/paginate', params)
  return resp.data.data
}
